import { Box, Divider, Button } from '@mui/material';
import React from 'react';
import { StyleObj } from '../../../../@types';
import Heading from '../../../atoms/Heading';
import useLocalization from '../../../../hooks/useLocalization';

const styles: StyleObj = {
  inputWrapper: {
    display: 'flex',
    justifyContent: 'center',
    p: '10px',
    alignItems: 'center',
  },
  fieldContainer: {
    width: '60%',
  },
  buttonWrapper: {
    p: '10px',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    borderRadius: '5px',
    width: '60%',
  },
  divider: {
    borderColor: 'neutral.300',
    borderBottomWidth: '2px',
  },
};
type StyledFormProps = {
  isSubmitting: boolean;
  headingText?: string;
  children: React.ReactNode;
};
const StyledForm = ({ isSubmitting, headingText, children }: StyledFormProps) => {
  const { t } = useLocalization();

  return (
    <>
      <Heading sx={{ justifyContent: 'center', height: 45 }}>
        <Heading.Title>{headingText ?? t('modify')}</Heading.Title>
      </Heading>
      <Divider sx={styles.divider} />
      <Box sx={styles.inputWrapper}>
        <Box sx={styles.fieldContainer}>{children}</Box>
      </Box>
      <Divider sx={styles.divider} />
      <Box sx={styles.buttonWrapper}>
        <Button type='submit' variant='contained' disabled={isSubmitting} sx={styles.button}>
          {t('save')}
        </Button>
      </Box>
    </>
  );
};

export default StyledForm;
